module.exports = __webpack_public_path__ + "img/tappi.ef0496e4.jpg";